var scope_0 = require('/builds/samurai-apps/website/src/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/954e30af6de5fafa69375f198b154cac.js').default;
var scope_1 = require('/builds/samurai-apps/website/src/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    